import {
  Component,
  OnChanges,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  ViewChild
} from "@angular/core";
import { RecordingService } from "@onsip/common/services/api/resources/recording/recording.service";
import { Recording } from "@onsip/common/services/api/resources/recording/recording";
import { Subscription } from "rxjs";
import { map, take } from "rxjs/operators";
import { MatTabGroup } from "@angular/material/tabs";
import { MatDialog } from "@angular/material/dialog";
import { ModalMaterialComponent } from "../../../shared/components/modal/modal-material.component";
import { TranslateService } from "@ngx-translate/core";
import { AdvAnnouncementWithExt } from "@onsip/web/features/administrators/announcements/announcementsPage/adv-announcements-page.component";

@Component({
  selector: "onsip-adv-announcements-shelf-container",
  templateUrl: "./adv-announcements-shelf-container.component.html",
  styleUrls: ["./adv-announcements-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdvAnnouncementsShelfComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(MatTabGroup) matTabGroup!: MatTabGroup;
  @Input() announcement!: AdvAnnouncementWithExt;
  @Input() transferToText!: string | undefined;
  recording: Recording | undefined;
  recordingsArray!: Array<Recording | undefined>;
  private prevSelectedIndex = 0;
  mode: "view" | "edit" = "view";

  private unsubscriber = new Subscription();

  constructor(
    private recordingService: RecordingService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.setRecording();
  }

  ngOnChanges() {
    this.setRecording();
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  setRecording() {
    this.unsubscriber.add(
      this.recordingService.orgState
        .pipe(
          map(recordingArray => {
            this.recordingsArray = [];
            recordingArray.map(record => this.recordingsArray.push(record));
            return recordingArray.find(
              recording => recording.number === this.announcement.recordingNumber
            );
          })
        )
        .subscribe(recording => {
          this.recording = recording;
        })
    );
    this.cdRef.markForCheck();
  }

  onSelectedIndexChange(event: number) {
    if (this.mode === "edit" && this.matTabGroup.selectedIndex !== this.prevSelectedIndex) {
      this.matTabGroup.selectedIndex = this.prevSelectedIndex;
      const modal = this.dialog.open(ModalMaterialComponent, {
        panelClass: ["mat-typography", "onsip-dialog-universal-style"],
        data: {
          title: this.translate.instant("ONSIP_I18N.CANCEL_EDITS"),
          message: this.translate.instant("ONSIP_I18N.ANY_CHANGES_YOU_HAVE_MADE_WILL_NOT_BE_SAVED"),
          primaryBtnText: this.translate.instant("ONSIP_I18N.OK"),
          secondaryBtnText: this.translate.instant("ONSIP_I18N.KEEP_EDITING"),
          primaryBtnFlat: true
        }
      });

      this.unsubscriber.add(
        modal
          .afterClosed()
          .pipe(take(1))
          .subscribe(retObj => {
            if (retObj && retObj.doPrimaryAction) {
              this.mode = "view";
              this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
              this.matTabGroup.selectedIndex = event;
              this.cdRef.markForCheck();
            } else if (retObj && !retObj.doPrimaryAction) {
              this.mode = "edit"; // pressed "keep editing"
            }
          })
      );
    } else {
      this.mode = "view";
      this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
      this.matTabGroup.selectedIndex = event;
    }
  }
}
